// Facebook Stories "add a button" call-to-action types
export const FACEBOOK_LINK_BUTTON_TYPES = ['SEE_MORE', 'LEARN_MORE', 'SWIPE_UP_SHOP', 'BOOK_NOW', 'CALL_NOW', 'GET_DIRECTIONS'];

export const FACEBOOK_WEBSITE_BUTTON_TYPES = FACEBOOK_LINK_BUTTON_TYPES.filter(type => type !== 'SWIPE_UP_SHOP');

export const FACEBOOK_LINK_DEFAULT_BUTTON_TYPE = 'SEE_MORE';

export const facebookLinkButtonTypeLabels = ($t, types = FACEBOOK_LINK_BUTTON_TYPES) => types.reduce((acc, type) => {
    acc[type] = $t(`dash.post-creator.story.link-button-type.${type.toLowerCase().replace(/_/g, '-')}`)
    return acc
}, {})
